export const MERCHANTS_PORTFOLIO = '/merchants_portfolio';
export const MERCHANT_PORTFOLIO_DETAILS = `${MERCHANTS_PORTFOLIO}/:id`;
export const MERCHANT_PORTFOLIO_DETAILS_TAB = `${MERCHANT_PORTFOLIO_DETAILS}/:tabValue`;
